import React from 'react';
import Styles from './expired-invitation-styles.scss';
import { AuthHeader, AuthLayout, AuthFooter } from '@/presentation/components';
import StepChanged from './components/step-changed';
const ExpiredInvitation = ({ addUser }) => {
    return (React.createElement(AuthLayout, null,
        React.createElement(AuthHeader, null),
        React.createElement("div", { className: Styles.loginWrap },
            React.createElement("div", { className: Styles.imgWrap },
                React.createElement("img", null)),
            React.createElement("div", { className: Styles.formWrap },
                React.createElement(StepChanged, { addUser: addUser }))),
        React.createElement(AuthFooter, null)));
};
export default ExpiredInvitation;
